import { Injectable, Injector } from '@angular/core';
import { HttpDataService } from './http-data.service';

@Injectable()
export class ArcadeService extends HttpDataService {
  constructor(protected injector: Injector) {
    super(injector, '/arcade');
  }
  resetLevel(licenseId) {
    return new Promise((resolve, reject) => {
      const data = { nickname: licenseId };
      super
        .postRequest(`${this.baseUrl}/resetLevel`, JSON.stringify(data), this.getRequestOptions())
        .then(resolve)
        .catch(reject);
    });
  }
  passLevel(licenseId) {
    return new Promise((resolve, reject) => {
      const data = { nickname: licenseId };
      super
        .postRequest(`${this.baseUrl}/passLevel`, JSON.stringify(data), this.getRequestOptions())
        .then(resolve)
        .catch(reject);
    });
  }
}
